import { useMemo } from 'react';

import { useDebtorCandidatesListQuery } from 'core/graphql';

interface IUseDebtorCandidateIdsOptions {
  /** Skip the query entirely (e.g. while the LMS filter doesn't need it). */
  skip?: boolean;
}

interface IUseDebtorCandidateIds {
  /** Student ids of the company-wide debtor candidates. */
  ids: Set<string>;
  loading: boolean;
}

/**
 * Company-wide debtor-candidate student ids (spec 0003): the existing
 * `DebtorCandidatesList` query with NO `groupId`, reduced to an id set so the
 * /students roster can mark «должники без блокировки» rows cheaply. `skip`
 * keeps the (potentially heavy) company-wide scan off the wire until the
 * corresponding filter is actually selected.
 */
export const useDebtorCandidateIds = ({
  skip = false,
}: IUseDebtorCandidateIdsOptions = {}): IUseDebtorCandidateIds => {
  const { data, loading } = useDebtorCandidatesListQuery({
    skip,
    fetchPolicy: 'cache-and-network',
  });

  const ids = useMemo(
    () =>
      new Set(
        (data?.debtorCandidates || []).map((candidate) => candidate.student.id),
      ),
    [data?.debtorCandidates],
  );

  return { ids, loading };
};
